import React from 'react';
import { Modal } from 'antd';

const TooManyEventsDialog = props => {
	const { visible, onCancel } = props;
	const supportEmail = 'support@thalo.app';

	return (
		<Modal title="Maximum Two Trial Events" open={visible} onCancel={onCancel} footer={null}>
			<div className="TooManyEventsDialog">
				<span>
					You can create up to two unpaid trial events. To pay for seats and activate one of your
					existing events, contact{' '}
				</span>
				<a href={`mailto:${supportEmail}`}>{supportEmail}</a>
				<span>.</span>
			</div>
		</Modal>
	);
};

export default TooManyEventsDialog;
